import { useHistory } from "react-router-dom";
import { InfoCard } from "components/Cards/InfoCard";
import { LineChart } from "components/Chart/LineChart";
import { Header } from "components/Header";
import { GlobalMap } from "components/Maps/GlobalMap";

import { useOccurrencesStatistics } from "services/OccurrenceService";
import { CheckAlert } from "utils/checkAlert";
import * as S from "./styles";
import { DashboardTemplate } from "templates/DashboardTemplate";

export function Dashboard() {
  const location = useHistory();
  const { data, error, isLoading } = useOccurrencesStatistics();
  CheckAlert();
  console.log(document.getElementById("root")?.getAttribute("style"));
  return (
    <S.Container>
      <DashboardTemplate containerClass={"containerClass"}>
        <Header title="Dashboard" />

        <S.MainContainer>
          <S.CardContainer>
            <InfoCard
              text="Ocorrências em andamento agora"
              link="/occurrences?type=inProgress"
              number={data?.item.occurrencesToday.progress.length || 0}
            />
            <InfoCard
              text="Ocorrências em aprovação agora"
              link="/occurrences?type=waiting"
              number={data?.item.occurrencesToday.approval.length || 0}
            />
            <InfoCard
              text="Ocorrências finalizadas hoje"
              link="/occurrences?type=finished"
              number={data?.item.occurrencesToday.finished.length || 0}
            />
          </S.CardContainer>

          {!isLoading && (
            <LineChart
              residence={data?.item.occurrencesThisWeek.residence}
              vehicle={data?.item.occurrencesThisWeek.vehicle}
            />
          )}
        </S.MainContainer>

        <S.MapContainer>
          <GlobalMap />
        </S.MapContainer>
      </DashboardTemplate>
    </S.Container>
  );
}
